import { RootState } from "../../../../store";
import { liveFilteredTrackedResourcesSelector } from "../liveFilteredTrackedResourcesSelector";

export const liveFilteredTrackedResourcesLoadingForViewSelector = (
  state: RootState,
) => {
  return !!liveFilteredTrackedResourcesSelector(state)?.isLoading;
};
